import React from 'react';

/**
 * LogoLoader Component
 * 
 * This component ensures that Logo.png is properly included in the build process
 * and available at the public URL path /Logo.png
 * 
 * It doesn't render anything visible to users
 */
const LogoLoader = () => {
  return (
    <div style={{ display: 'none', position: 'absolute', width: '1px', height: '1px', overflow: 'hidden' }}>
      <img src="/Logo.png" alt="TensorPilot Logo" />
    </div>
  );
};

export default LogoLoader;
